import { render } from "./MessageItemSpeech.vue?vue&type=template&id=18002983&scoped=true"
import script from "./MessageItemSpeech.vue?vue&type=script&lang=js"
export * from "./MessageItemSpeech.vue?vue&type=script&lang=js"

import "./MessageItemSpeech.vue?vue&type=style&index=0&id=18002983&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18002983"]])

export default __exports__